import $api from "../../../../services/axiosService";
import { deleteAttachmentAction } from "../deleteAttachment.action";

export const deleteAttachmentThunkAction = ({ attachId, requestId, setDeleteStatus }) => async (dispatch) => {
    try {
        setDeleteStatus &&    setDeleteStatus(true);
        await $api.delete(`v1/leaverequest/${requestId}/upload/${attachId}`);
        dispatch(deleteAttachmentAction(attachId));
        setDeleteStatus &&  setDeleteStatus(false);
    } catch (error) {
        setDeleteStatus &&   setDeleteStatus(false);
    }

};
